import * as ACTION_TYPES from '../types';

let initialState = {
  poolList: [],
  pool: {},
  poolList_by_query: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_POOLS:
      return { ...state, poolList: action.data };
    case ACTION_TYPES.DELETE_POOL:
    let newList = state.poolList.filter(pool => pool._id !== action.id);
      return {...state, poolList: newList };
    case ACTION_TYPES.REQUEST:
      return { ...state, loading: true };
    case ACTION_TYPES.DONE:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_POOLS:
      return { ...state, poolList: [] };
    case ACTION_TYPES.GET_POOL_BY_ID:
      return { ...state, pool: action.data }
    case ACTION_TYPES.GET_POOL_BY_QUERY:
      return { ...state, poolList_by_query: action.data }
    default:
      return state;
  }
};